import api from './api';

export const getSubscription = () => api.get('/billing/subscription').then((r) => r.data);

export const changePlan = (tier) => api.post('/billing/subscription/plan', { tier }).then((r) => r.data);

export const listInvoices = () => api.get('/billing/invoices').then((r) => r.data);

export const getSettlement = (params = {}) => api.get('/billing/settlement', { params }).then((r) => r.data);

export const getGstReport = (params = {}) => api.get('/billing/gst-report', { params }).then((r) => r.data);

// Admin
export const adminListSubscriptions = () => api.get('/billing/admin/subscriptions').then((r) => r.data);
export const adminUpdateSubscription = (shopId, payload) =>
  api.patch(`/billing/admin/shops/${shopId}`, payload).then((r) => r.data);
export const adminSettleCommission = (shopId, payload) =>
  api.post(`/billing/admin/settle/${shopId}`, payload).then((r) => r.data);
export const adminRevenueSummary = () => api.get('/billing/admin/revenue').then((r) => r.data);
